import type * as React from "react";

import {
  useHasOrgRole,
  type OrgRole,
  type OrgRoleOptions,
} from "@/providers/auth/hooks";

type OrgRoleOnlyProps = OrgRoleOptions & {
  /** The lowest role that sees the children. */
  role: OrgRole;
  fallback?: React.ReactNode;
  children: React.ReactNode;
};

/**
 * Renders children only for a user who may act as `role` in the org, which
 * includes Roboto system users unless `systemUsers` is false; see
 * {@link useHasOrgRole}.
 */
export const OrgRoleOnly: React.FC<OrgRoleOnlyProps> = ({
  role,
  fallback = null,
  children,
  ...options
}) => (useHasOrgRole(role, options) ? children : fallback);
